import { render, staticRenderFns } from "./FamiliaSegura.vue?vue&type=template&id=595b936e&scoped=true&"
import script from "./FamiliaSegura.vue?vue&type=script&lang=js&"
export * from "./FamiliaSegura.vue?vue&type=script&lang=js&"
import style0 from "./FamiliaSegura.vue?vue&type=style&index=0&id=595b936e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595b936e",
  null
  
)

export default component.exports